// extracted by mini-css-extract-plugin
export default {"iconCard":"Community_iconCard__Bc2IC","communityHeading":"Community_communityHeading__sCiSg","communityDescription":"Community_communityDescription__ia1ec"};